import * as React from 'react';

const prIcon = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="16" height="16" fill="#E5E5E5" />
    <path
      d="M-2693 -3488C-2693 -3489.1 -2692.1 -3490 -2691 -3490H5776C5777.1 -3490 5778 -3489.1 5778 -3488V983H-2693V-3488Z"
      fill="#024EC1"
      fillOpacity="0.03"
    />
    <path
      d="M5778 983V984H5779V983H5778ZM-2693 983H-2694V984H-2693V983ZM-2691 -3489H5776V-3491H-2691V-3489ZM5777 -3488V983H5779V-3488H5777ZM5778 982H-2693V984H5778V982ZM-2692 983V-3488H-2694V983H-2692ZM5776 -3489C5776.55 -3489 5777 -3488.55 5777 -3488H5779C5779 -3489.66 5777.66 -3491 5776 -3491V-3489ZM-2691 -3491C-2692.66 -3491 -2694 -3489.66 -2694 -3488H-2692C-2692 -3488.55 -2691.55 -3489 -2691 -3489V-3491Z"
      fill="black"
      fillOpacity="0.1"
    />
    <path
      d="M-623 -1408C-623 -1409.1 -622.105 -1410 -621 -1410H857C858.105 -1410 859 -1409.1 859 -1408V520C859 521.104 858.105 522 857 522H-621C-622.105 522 -623 521.105 -623 520V-1408Z"
      fill="white"
    />
    <path
      d="M-621 -1409H857V-1411H-621V-1409ZM858 -1408V520H860V-1408H858ZM857 521H-621V523H857V521ZM-622 520V-1408H-624V520H-622ZM-621 521C-621.552 521 -622 520.552 -622 520H-624C-624 521.657 -622.657 523 -621 523V521ZM858 520C858 520.552 857.552 521 857 521V523C858.657 523 860 521.657 860 520H858ZM857 -1409C857.552 -1409 858 -1408.55 858 -1408H860C860 -1409.66 858.657 -1411 857 -1411V-1409ZM-621 -1411C-622.657 -1411 -624 -1409.66 -624 -1408H-622C-622 -1408.55 -621.552 -1409 -621 -1409V-1411Z"
      fill="black"
      fillOpacity="0.1"
    />
    <g filter="url(#filter0_d_1342_10237)">
      <path
        d="M-522 -69H758V414C758 418.418 754.418 422 750 422H-514C-518.418 422 -522 418.418 -522 414V-69Z"
        fill="white"
      />
      <path
        d="M758.5 -69.5V414C758.5 418.694 754.694 422.5 750 422.5H-514C-518.694 422.5 -522.5 418.694 -522.5 414V-69.5H758.5Z"
        stroke="#D1D1D1"
      />
      <rect x="-2" y="-2" width="20" height="20" rx="4" fill="white" />
      <g clipPath="url(#clip0_1342_10237)">
        <path
          d="M5.25 0.835217C5.62707 1.05293 5.94074 1.36535 6.15995 1.74154C6.37917 2.11774 6.49634 2.54466 6.49986 2.98005C6.50337 3.41544 6.39312 3.84421 6.18001 4.22389C5.96689 4.60358 5.65831 4.92102 5.28481 5.1448C4.91131 5.36857 4.48584 5.49092 4.05052 5.49973C3.61521 5.50854 3.18514 5.40351 2.80289 5.19503C2.42064 4.98655 2.09947 4.68185 1.87117 4.3111C1.64287 3.94034 1.51535 3.5164 1.50125 3.08122L1.5 3.00022L1.50125 2.91922C1.51525 2.48746 1.64089 2.06671 1.86591 1.69797C2.09093 1.32922 2.40766 1.02508 2.78522 0.815188C3.16278 0.605295 3.58829 0.496816 4.02025 0.500327C4.45222 0.503837 4.8759 0.619217 5.25 0.835217ZM4.92675 2.32347C4.8837 2.28042 4.82643 2.25457 4.76567 2.25075C4.70491 2.24692 4.64485 2.2654 4.59675 2.30272L4.57325 2.32347L3.75 3.14647L3.42675 2.82347L3.40325 2.80272C3.35515 2.76543 3.29509 2.74697 3.23435 2.75081C3.17361 2.75464 3.11635 2.7805 3.07332 2.82353C3.03028 2.86657 3.00442 2.92383 3.00059 2.98457C2.99676 3.04531 3.01521 3.10536 3.0525 3.15347L3.07325 3.17697L3.57325 3.67697L3.59675 3.69772C3.64059 3.73173 3.69451 3.7502 3.75 3.7502C3.80549 3.7502 3.85941 3.73173 3.90325 3.69772L3.92675 3.67697L4.92675 2.67697L4.9475 2.65347C4.98481 2.60537 5.00329 2.5453 4.99947 2.48455C4.99565 2.42379 4.96979 2.36652 4.92675 2.32347Z"
          fill="white"
        />
      </g>
      <g clipPath="url(#clip1_1342_10237)">
        <path
          d="M12.0172 6.225C12.0057 6.16398 11.9999 6.10202 11.9999 6.03992V1.0666C11.9999 0.854428 11.9156 0.650945 11.7656 0.500916C11.6156 0.350887 11.4121 0.266602 11.1999 0.266602H1.0666C0.854428 0.266602 0.650945 0.350887 0.500916 0.500916C0.350887 0.650945 0.266602 0.854428 0.266602 1.0666V13.8666C0.266602 14.1117 0.314884 14.3545 0.408693 14.5809C0.502502 14.8074 0.64 15.0132 0.813336 15.1865C0.986672 15.3599 1.19245 15.4974 1.41893 15.5912C1.6454 15.685 1.88813 15.7333 2.13327 15.7333H12.602C13.2285 15.7333 13.7007 15.1638 13.5847 14.5482L12.0172 6.225Z"
          fill="url(#paint0_linear_1342_10237)"
        />
        <path
          d="M15.7333 6.66663V13.8666C15.7333 14.1118 15.685 14.3545 15.5912 14.581C15.4974 14.8075 15.3599 15.0132 15.1865 15.1866C15.0132 15.3599 14.8074 15.4974 14.581 15.5912C14.3545 15.685 14.1118 15.7333 13.8666 15.7333H13.8079C13.3142 15.7045 12.8506 15.4863 12.5138 15.1241C12.177 14.762 11.9929 14.2838 11.9999 13.7893V6.1333H15.1999C15.3413 6.13372 15.4767 6.19005 15.5766 6.28998C15.6765 6.3899 15.7329 6.52532 15.7333 6.66663Z"
          fill="url(#paint1_linear_1342_10237)"
        />
        <rect
          x="2"
          y="6"
          width="8"
          height="1"
          rx="0.5"
          fill="url(#paint2_linear_1342_10237)"
        />
        <rect
          x="2"
          y="2"
          width="8"
          height="1"
          rx="0.5"
          fill="url(#paint3_linear_1342_10237)"
        />
        <rect
          x="2"
          y="8"
          width="8"
          height="1"
          rx="0.5"
          fill="url(#paint4_linear_1342_10237)"
        />
        <rect
          x="2"
          y="4"
          width="8"
          height="1"
          rx="0.5"
          fill="url(#paint5_linear_1342_10237)"
        />
        <rect
          x="2"
          y="10"
          width="8"
          height="1"
          rx="0.5"
          fill="url(#paint6_linear_1342_10237)"
        />
        <rect
          x="2"
          y="12"
          width="8"
          height="1"
          rx="0.5"
          fill="url(#paint7_linear_1342_10237)"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_1342_10237"
        x="-549.7"
        y="-96.7"
        width="1335.4"
        height="546.4"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="10"
          operator="dilate"
          in="SourceAlpha"
          result="effect1_dropShadow_1342_10237"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="8.35" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1342_10237"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1342_10237"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_1342_10237"
        x1="11.6764"
        y1="13.363"
        x2="-5.38327"
        y2="7.52457"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2744FF" />
        <stop offset="1" stopColor="#B9D5FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1342_10237"
        x1="14.745"
        y1="13.219"
        x2="8.47663"
        y2="11.7397"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BDD1E7" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1342_10237"
        x1="7.88235"
        y1="6.7381"
        x2="7.30515"
        y2="3.93608"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BDD1E7" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1342_10237"
        x1="7.88235"
        y1="2.7381"
        x2="7.30515"
        y2="-0.0639226"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BDD1E7" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_1342_10237"
        x1="7.88235"
        y1="8.7381"
        x2="7.30515"
        y2="5.93608"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BDD1E7" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_1342_10237"
        x1="7.88235"
        y1="4.7381"
        x2="7.30515"
        y2="1.93608"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BDD1E7" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_1342_10237"
        x1="7.88235"
        y1="10.7381"
        x2="7.30515"
        y2="7.93608"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BDD1E7" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_1342_10237"
        x1="7.88235"
        y1="12.7381"
        x2="7.30515"
        y2="9.93608"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BDD1E7" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <clipPath id="clip0_1342_10237">
        <rect width="6" height="6" fill="white" transform="translate(1)" />
      </clipPath>
      <clipPath id="clip1_1342_10237">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default prIcon;
